import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import {
  Card,
  FlexAlign,
  TitleDivision,
  Text,
  Division,
  Details,
  ButtonDivision,
  ItemsSummary,
  TitleSummary,
  LoadingIcon,
} from './styles';
import api from '~/services/api';
import { InfoButton } from '~/components/layout/Buttons';
import IconProduct from '~/components/layout/IconProduct';
import { hasNumberInString, replaceNumberInString } from '~/utils/utils';

export default function SummaryOrder(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const orderStored = useSelector(state => state.orderReducer);
  const items = useSelector(state => state.orderReducer.items);
  const observation = useSelector(state => state.orderReducer.observation);
  const selectedBranch = useSelector(
    state => state.orderReducer.selectedBranch,
  );

  const [loading, setLoading] = useState(false);

  const createOrder = async () => {
    setLoading(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const url = `/residential/order/v1/orders-ga`;
    const contactId = localStorage.getItem('contactIdSf');
    const storeId = localStorage.getItem('storeId');
    const supplyBrancheId = localStorage.getItem('supplyBranchId');
    const date = orderStored.date;
    const products = [];
    items.map(product => {
      products.push({
        code: product.product.code,
        quantity: product.quantity,
      });
    });

    let body = {};
    if (observation !== 'Nenhuma observação') {
      if (observation !== '') {
        body = {
          storeId,
          supplyBrancheId,
          serviceType:
            orderStored.order.typeOrder === 'Retira' ? 'RETIRA' : 'ENTREGA',
          contactId,
          orderType: 'GAS_ENVASADO',
          deliveryDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          products,
          observation,
        };
      } else {
        body = {
          storeId,
          supplyBrancheId,
          serviceType:
            orderStored.order.typeOrder === 'Retira' ? 'RETIRA' : 'ENTREGA',
          contactId,
          orderType: 'GAS_ENVASADO',
          deliveryDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          products,
        };
      }
    } else {
      body = {
        storeId,
        supplyBrancheId,
        serviceType:
          orderStored.order.typeOrder === 'Retira' ? 'RETIRA' : 'ENTREGA',
        contactId,
        orderType: 'GAS_ENVASADO',
        deliveryDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        products,
      };
    }

    const parameters = {
      method: 'POST',
      headers: header,
    };
    if (body.deliveryDate === 'Invalid date') {
      toast.error('A data está inválida');
      setLoading(false);
      return;
    }
    await api
      .post(url, body, parameters)
      .then(res => {
        setLoading(false);
        toast.success('Pedido realizado com sucesso');
        setTimeout(() => {
          window.location = '/portal';
          dispatch({ type: 'ORDER_DONE' });
        }, 2000);
      })
      .catch(err => {
        setLoading(false);
        let displayToast = false;

        const errorsForDisplayApi = [
          "Não foi possível efetuar o cancelamento do pedido. Favor entrar em contato com a logística da filial",
          "A data informada ultrapassa o prazo para gerar pedido com antecedência. Prazo: {number} dias",
          "A filial abastecedora não trabalha neste dia da semana",
          "A data informada é um feriado, favor informar um dia útil.",
          "O horário de atendimento da revenda para pedidos nesta data foi excedido."
        ]
        const errosDefined = {
          "A filial abastecedora não possui um calendário de trabalho cadastrado": "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.",
          "A quantidade solicitada no pedido excede o volume permitido.Volume total solicitado: {number} kg. Volume total permitido: {number} kg.": "Quantidade acima do permitido"
        }
        const errorDefault = "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.";

        const message = hasNumberInString(err.response.data.message) ? replaceNumberInString(err.response.data.message, "{number}") : err.response.data.message;
        if (err.response.status !== 502) {
          for (const error of errorsForDisplayApi){
            if (message.includes(error)) {
              if (message === error) {
                displayToast = true;
                toast.error(err.response.data.message);
              } else {
                if (!displayToast){
                  const messagesSplitedDisplay = err.response.data.message.split(';')
                  if (messagesSplitedDisplay.length <= 2) {
                    displayToast = true;
                    toast.error(messagesSplitedDisplay[0]);
                  } else {
                    displayToast = true;
                    toast.error(messagesSplitedDisplay[0]);
                    toast.error(messagesSplitedDisplay[messagesSplitedDisplay.length -1]);
                  }
                }
              }
            }
          }
          for (const key in errosDefined) {
            if (message.includes(key)) {
              if (message === key) {
                displayToast = true;
                toast.error(errosDefined[key]);
              } else {
                const messagesSplitedDefined = message.split(';')
                if (messagesSplitedDefined.length <= 2) {
                  if (messagesSplitedDefined[0] === key) {
                    displayToast = true;
                    toast.error(errosDefined[key]);
                  }
                } else {
                  if (messagesSplitedDefined[0] === key) {
                    displayToast = true;
                    toast.error(errosDefined[key]);
                  }
                  if (messagesSplitedDefined[messagesSplitedDefined.length -1] === key) {
                    displayToast = true;
                    toast.error(errosDefined[key]);
                  }
                }
              }
            }
          }
          if (!displayToast) {
            toast.error(errorDefault);
          }
        } else {
          toast.error('Ocorreu um erro, tente novamente!');
        }
      });
  };

  return (
    <>
      <TitleSummary>Resumo do pedido</TitleSummary>
      <Card>
        <ItemsSummary>
          {orderStored.order.typeOrder !== null ? (
            items.map((item, index) => (
              <Division key={index + 1}>
                <FlexAlign style={{ margin: "0rem .5rem 0rem .5rem" }}>
                  <Text>Item {index + 1}</Text>
                  <Text>Quantidade</Text>
                </FlexAlign>
                <FlexAlign style={{ margin: "0rem .5rem 0rem .5rem" }}>
                  <span>
                    <IconProduct
                      productName={item.product.name}
                      styles={{
                        p2: { width: '15%', margin: '0 .3rem .1rem 0' },
                        p5: { width: '15%', margin: '0 .3rem .1rem 0' },
                        p20: { width: '9%', margin: '0 .3rem .1rem 0' },
                        p45: { width: '9%', margin: '0 .3rem .1rem 0' },
                        p90: { width: '9%', margin: '0 .3rem .1rem 0' },
                        p13: { width: '15%', margin: '0 .3rem .1rem 0' },
                      }}
                    />
                    {item.product.name}
                  </span>
                  <Text>
                    <strong>{item.quantity}</strong>
                  </Text>
                </FlexAlign>
              </Division>
            ))
          ) : (
            <></>
          )}
        </ItemsSummary>
        <Details>
          <TitleDivision>Detalhes</TitleDivision>
          <Text>
            <strong>Tipo Pedido</strong>
            <p>{orderStored.order.typeOrder}</p>
          </Text>
          <Text>
            <strong>Data Prevista</strong>
            <p>{orderStored.date}</p>
          </Text>
          <Text>
            <strong>Filial</strong>
            <p>{props.branches[selectedBranch ? selectedBranch : 0].name}</p>
          </Text>
          {observation !== '' ? (
            observation !== 'Nenhuma observação' ? (
              <Text>
                <strong>Observação</strong>
                <p>{observation}</p>
              </Text>
            ) : null
          ) : null}
        </Details>
      </Card>

      {orderStored.order.typeOrder === 'Retira' ? (
        <ButtonDivision onClick={() => history.push('/confirmacao-pedido')}>
          <InfoButton style={{ margin: "-1rem 0 1rem 0" }} disabled={loading}>
            {loading ? (
              <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
            ) : (
              <div>Fechar pedido</div>
            )}
          </InfoButton>
        </ButtonDivision>
      ) : (
        <ButtonDivision onClick={() => createOrder()}>
          <InfoButton style={{ margin: "-1rem 0 1rem 0" }} margin={'1rem 0'} disabled={loading}>
            {loading ? (
              <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
            ) : (
              <div>Fechar pedido</div>
            )}
          </InfoButton>
        </ButtonDivision>
      )}
    </>
  );
}
